import React from 'react';
import { captureException } from '../telemetry/posthog';
import './moduleErrorBoundary.css';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Unhandled UI error:', error);
    // PostHog error telemetry (RSW-591). Safe no-op when unconfigured.
    captureException(error, {
      source: 'AppErrorBoundary',
      componentStack: errorInfo?.componentStack || '',
    });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="ws-module-error ws-module-error--fullpage" role="alert">
        <div className="ws-module-error__card">
          <div className="ws-module-error__icon" aria-hidden>!</div>
          <h2 className="ws-module-error__title">Something went wrong</h2>
          <p className="ws-module-error__body">
            The application encountered an unexpected issue. Your saved work is safe.
          </p>
          <div className="ws-module-error__actions">
            <button
              type="button"
              className="ws-module-error__btn ws-module-error__btn--primary"
              onClick={() => window.location.reload()}
            >
              Reload application
            </button>
            {/* RSW-448: when the crash is deterministic on this route, reloading
                re-crashes instantly and reads as "the button did nothing".
                Navigating to the start switches code paths and escapes the trap. */}
            <button
              type="button"
              className="ws-module-error__btn ws-module-error__btn--secondary"
              onClick={() => window.location.assign('/')}
            >
              Go to start
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default AppErrorBoundary;
